import React from "react"
import { Typography, Grid, Button, Paper } from "@material-ui/core"
//import { Link } from "gatsby"
import { Link } from "gatsby-theme-material-ui"
import { makeStyles } from "@material-ui/core/styles"

import { Container } from "@material-ui/core"
import Seo from "../components/seo"
import Parallax from "../components/Parallax/Parallax"
import LeistungenSection from "../sections/leistungen.en"
import KundenSection from "../sections/kunden.en"
import KontaktSection from "../sections/kontakt.en"
//import TechnologienWerkzeugeSection from "../sections/technologien-werkzeuge";
import Footer from "../components/footer.en"
import Header from "../components/header.en"
//import BackgroundMusic from "../components/BackgroundMusic";

import { graphql } from "gatsby"
//import infoSoundFile from "../assets/sound/gratis_erstberatung.mp3"
import { Helmet } from "react-helmet"

const IndexPageStyle = theme => ({
  hero: {
    [theme.breakpoints.up("lg")]: {
      marginTop: "5rem",
    },
    marginTop: "5rem",
    zIndex: "2",
    color: "#FFFFFF",
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  main: {
    [theme.breakpoints.up("lg")]: {
      margin: "-3rem 2rem 0 2rem",
    },
    zIndex: "3",
    position: "relative",
  },
  name: {
    fontStyle: "italic",
    fontFamily: "serif",
  },
})

const useStyles = makeStyles(IndexPageStyle)

const IndexPageEN = ({ data }) => {
  const classes = useStyles()
  return (
    <>
      <Seo title="Welcome - Software & Transformation" lang="en" slug="en/" />
      <Helmet>
        <link rel="alternate" href="/" hreflang="de" />
      </Helmet>
      <Header />
      <Parallax filter image={data.hero.childImageSharp.gatsbyImageData}>
        <Container maxWidth="lg" className={classes.hero}>
          <Grid container>
            <Grid item xs={12} sm={6} md={7}>
              <Typography variant="h1" component="h1" className={classes.title}>
                Your success. Our pleasure.
              </Typography>
              <Typography variant="h5" component="h4">
                We put a smile on the faces of a technology-loving world and
                make online experiences unforgettable for customers and partners{" "}
                <span className={classes.name}>
                  ‒ Andreas Heissenberger, Technology Mediator
                </span>
              </Typography>
              <br />

              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="#kontakt"
                size="large"
              >
                Free initial consultation
              </Button>
              {/* <BackgroundMusic sound={infoSoundFile} title={'Info'} /> */}
            </Grid>
          </Grid>
        </Container>
      </Parallax>

      <div className={classes.main}>
        <Paper style={{ backgroundColor: "white" }}>
          <LeistungenSection data={data} />
          <KundenSection kunden={data.kunden?.edges ?? []} />
          <KontaktSection />
          {/* <TechnologienWerkzeugeSection  data={data}  /> */}
          <div style={{ height: "5rem" }} />
        </Paper>
      </div>
      <Footer />
    </>
  )
}

export default IndexPageEN

export const query = graphql`
  {
    hero: file(relativePath: { eq: "landing-bg.jpg" }) {
      childImageSharp {
        gatsbyImageData(height: 1000, quality: 85, layout: FULL_WIDTH)
      }
    }
    kunden: allMdx(
      filter: {
        frontmatter: {
          posttype: { eq: "client" }
          publishstate: { eq: "published" }
        }
      }
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            website
            images {
              publicURL
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
    beratung: file(relativePath: { eq: "Stories Illustrations_Support.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 600
          aspectRatio: 2.8
          quality: 85
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    software: file(relativePath: { eq: "Stories Illustrations_Sign in.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 600
          aspectRatio: 2.8
          quality: 85
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    labor: file(relativePath: { eq: "Stories Illustrations_Settings.png" }) {
      childImageSharp {
        gatsbyImageData(
          width: 600
          aspectRatio: 2.8
          quality: 85
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
  }
`
